import { Component, forwardRef, Renderer2, ViewChild, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CompanyService } from '../../../service/company/company.service';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { Company } from '../../../class/company';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MultiSelectCompaniesComponent),
  multi: true,
};

@Component({
  selector: 'app-multiselect-companies',
  templateUrl: './multiselect-companies.component.html',
  styleUrls: ['./multiselect-companies.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class MultiSelectCompaniesComponent implements ControlValueAccessor {
    @Input() companiesId: Company[];
    @ViewChild('input') textarea;

    public companies: AbstractControl;
    public companiesSelected: SelectItem[];
    public companiesOptions: SelectItem[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public companyService: CompanyService
    ) {
        this.page = 1;
        this.per_page = 1000;
        this.query = undefined;
        this.filters = [];
        this.getCompanies(this.query, this.filters);
    }

    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean ) {
        const div = this.textarea.nativeElement;
        const action = isDisabled ? 'addClass' : 'removeClass';
        this.renderer[action](div, 'disabled');
    }

    public change($event) {
        this.onChange($event.value);
        this.onTouched($event.value);
    }

    getCompanies(query?: string, filters?: any[]) {
        this.companyService.getCompany(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                const companies = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }

                this.companiesOptions = [];
                companies.forEach(element => {
                    this.companiesOptions.push({'value': element.id, 'label': element.name});
                });

                if (this.companiesId) {
                    this.companiesSelected = [];
                    this.companiesId.forEach(element => {
                        this.companiesSelected.push({'value': element.id, 'label': element.name});
                    });
                }
            },
            error => {
                this.companiesOptions = [];
                this.companiesOptions.push({value: '', label: 'Error'});
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/companies/multiselect-companies/multiselect-companies.component.ts